module.exports = __webpack_public_path__ + "img/v1.4.a7f65432.png";